import Vue from 'vue'
import api from './api'

import App from './App'
import router from './router'
import store from './store'
import './components'

import moment from 'moment'
import md5 from "md5";

Vue.api = Vue.prototype.$api = api
Vue.md5 = Vue.prototype.$md5 = md5
Vue.config.productionTip = false


var durationStr = function (usedTime) {
  if (isNaN(usedTime) || usedTime == 0) return ''
  var days = Math.floor(usedTime / (24 * 3600 * 1000))
  var leavel = usedTime % (24 * 3600 * 1000)
  var hours = Math.floor(leavel / (3600 * 1000))
  var leavel2 = leavel % (3600 * 1000)
  var minutes = Math.floor(leavel2 / (60 * 1000))
  var leavel3 = leavel % (60 * 1000)
  var seconds = Math.floor(leavel3 / 1000)
  var string = days > 0 ? days + '天' : ''
  string += hours > 0 ? hours + '小时' : ''
  string += minutes > 0 ? minutes + '分钟' : ''
  if (!(days||hours||minutes)) string = seconds + '秒钟'
  return string
}

Vue.filter('format', (value, pattern) => {
	if(value == undefined){return ''}
	return moment(value).format(pattern || "YYYY-MM-DD")
})

Vue.filter('formatRecordType', (value) => {
  switch (value) {
    case 1:
      return '哺乳'
    case 2:
      return '瓶喂母乳'
    case 3:
      return '配方奶'
    case 4:
      return '睡眠'
    case 5:
      return '换尿裤'
    case 6:
      return '随手记'
  }
})
Vue.filter('formatRecord', (data) => {
  switch (data.recordType) {
    case 1:
      if (data.timing) {
        return '哺乳中'
      }
      let side = ''
      if (data.feedSide === 0) {
        side = '左'
      }
      if (data.feedSide === 1) {
        side = '右'
      }
      return side + durationStr(data.endTime - data.startTime)
    case 2:
      return data.amount + 'ml'
    case 3:
      return data.amount + 'ml'
    case 4:
      if (data.timing) {
        return '宝宝正在睡觉'
      }
      if (!data.endTime) {
        return '开始睡觉'
      }
      console.log(data)
      return '睡醒了 睡了' + durationStr(data.endTime - data.startTime)
    case 5:
      return data.typeB?'大便'+['','/少','/中','/多'][data.amountB]:'' + data.typeA?'小便'+['','/少','/中','/多'][data.amountA]:''
    case 6:
      return data.content
  }
})

/* eslint-disable no-new */
new Vue({
  components: { App },
  router,
  store,
  template: '<App/>'
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js